export default __webpack_public_path__ + "static/media/Custom-HUD-Targeting (TD).c2ba1cf6.jpg";